import { render } from "./TFACodeField.vue?vue&type=template&id=b80c0b58"
import script from "./TFACodeField.vue?vue&type=script&lang=js"
export * from "./TFACodeField.vue?vue&type=script&lang=js"

import "./TFACodeField.vue?vue&type=style&index=0&id=b80c0b58&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__